var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"props":_vm.defaultProps,"node-key":"id","show-checkbox":""},on:{"node-click":_vm.handleNodeClick,"check-change":_vm.handleCheckChange}}),_c('el-button',{on:{"click":_vm.manually_set}},[_vm._v("Manuall Set")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }